<script>
    import jQuery from "jquery";
    import {getCookie} from "./gppy-misc";

    let i18 = {
        "pl": {
            "Login to GardenPuzzle": "Logowanie do GardenPuzzle",
            "Email or username:": "Email lub nazwa użytkownika:",
            "Password:": "Hasło:",
            "Login": "Zaloguj",
            "Forgot password?": "Zapomniane hasło?",
            "Click here.": "Kliknij tutaj.",
            "You don't have an account?": "Nie masz konta?",
            "Join GardenPuzzle community now!": "Dołącz do naszej społeczności!",
            "Choose a plan": "Kup teraz",
            "Password reset link has been sent to your email address." : "Link do ustawienia nowego hasła został wysłany na Twój adres email."
        }
    }

    let lang = document.documentElement.getAttribute("lang").toLowerCase() === "pl" ? "pl" : "en";

    let email;
    let password;
    let hasError = false;
    let errorMessages = '';
    let passMessage;
    $: disabled = !email || email.length === 0 || !password || password.length === 0;
    $: {
        let justRefresh = email || password; hasError = false; passMessage = null;
    }

    function t(message) {
        if (lang === "en") return message;
        if (lang === "pl") return i18['pl'][message] ? i18['pl'][message] : message;
    }


    export function showLoginForm () {
        email = '';
        password = '';
        hasError = false;
        jQuery('#loginForm').modal({});
        jQuery('#loginForm').on('hidden.bs.modal', () => this.$destroy());
        jQuery('#loginForm').on('shown.bs.modal',function (){jQuery('#loginFormEmail').focus();});

        jQuery('#loginForm input').on('keyup', (e) => {
            if (e.which == 13 && !disabled) login();
        });

        return false;
    }

    function login() {
        Promise.resolve(jQuery.post('/accounts/login/', {
            'login': email,
            'password': password
        })).then(
            logged,
            showError)
    }

    function logged() {
        window.location = window.location.pathname;
    }

    function showError(res) {
        hasError = true;
        var errors = res.responseJSON.form.errors;
        var errorshtml = errors.map(function(el){return '<span class="help-block">'+el+'</span>'});
        errorMessages = errorshtml.reduce(function(con, el){return con+el},"");
    }

    function resetPassword() {
        fetch('/accounts/password/reset/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json',
                'X-CSRFToken': getCookie('csrftoken')
            },
            body: 'email=' + encodeURIComponent(email)
        }).then(
            async (res) => {
                if (res.status === 200) {
                    hasError = false;
                    passMessage = t("Password reset link has been sent to your email address.");
                } else {
                    let ans = await res.json();
                    let err = ans.form.fields.email.errors[0];
                    passMessage = err;
                }
            }
        );
    }

</script>

<div id="loginForm" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">{t("Login to GardenPuzzle")}</h4>
      </div>
      <div class="modal-body loginFormEmail">
        <div class="form-group">
            <label for="loginFormEmail">{t("Email or username:")}</label>
            <input id="loginFormEmail" type="email" name="email" bind:value="{email}"/>
        </div>
        <div class="form-group loginFormPass">
            <label for="loginFormPass">{t("Password:")}</label>
            <input id="loginFormPass" type="password" name="password" bind:value="{password}"/>
        </div>
        {#if hasError}
            <div class="form-group loginFormText3 has-error">
                {@html errorMessages}
            </div>
        {/if}
        <div class="form-group-horizontal">
            <div class="form-group">
                <button on:click={login} type="button" class="btn btn-primary" class:disabled="{disabled}" >{t("Login")}</button>
            </div>
            <div class="form-group forgottenpass">
                {t("Forgot password?")} <a on:click={resetPassword}>{t("Click here.")}</a>
            </div>
        </div>
        {#if passMessage}
        <div class="form-group passmessage">
            {passMessage}
        </div>
        {/if}
      </div>
      <div class="modal-footer">
        <div class="form-group-horizontal">
            <div class="form-group">
              <h4>{t("You don't have an account?")}</h4>
              <h5>{t("Join GardenPuzzle community now!")}</h5>
            </div>
            <div class="form-group">
              <a href="/pricing" role="button" class="btn btn-success">{t("Choose a plan")}</a>
            </div>
        </div>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->